import React from 'react'
import './bio.scss'
import useBio from './../../hooks/getBio/useBio';

const Bio = () => {

    const bio = useBio();

    return (
        <div className="bio">
            <div className="bio_floated"></div>
            <div className="bio_text">
                <p>{bio.description}</p>
            </div>
            <div className="bio_square">
            </div>
        </div>
    )
}

export default Bio
